// Bounded ring buffer for stderr classifier evidence (review fix 2). Trims
// PROGRESSIVELY as chunks arrive -- never lets the internal buffer grow past
// the configured cap, unlike the old approach of collecting an unbounded
// array and slicing only at finalize time. Keeps the TAIL (most recent
// bytes), since that is what the error-classifier needs for evidence.
export class StderrRingBuffer {
  private readonly capBytes: number;
  private buffer = "";

  constructor(ringKib: number) {
    this.capBytes = ringKib * 1024;
  }

  push(chunk: string): void {
    this.buffer += chunk;
    this.trimToCap();
  }

  read(): string {
    return this.buffer;
  }

  currentSizeBytes(): number {
    return Buffer.byteLength(this.buffer, "utf8");
  }

  private trimToCap(): void {
    // Trim by UTF-8 byte length (not JS string .length) so the cap means
    // what stderrRingKib documents: a byte budget, not a code-unit budget.
    while (Buffer.byteLength(this.buffer, "utf8") > this.capBytes && this.buffer.length > 0) {
      // Drop from the head in growing chunks to avoid O(n^2) single-char
      // trimming on a large overflow; the exact trim boundary need not be
      // byte-precise, only bounded-and-tail-preserving.
      const dropChars = Math.max(1, Math.ceil(this.buffer.length * 0.1));
      this.buffer = this.buffer.slice(dropChars);
    }
  }
}
